/* eslint-disable max-len */
import React from 'react';
import { Row, Col } from 'antd';
import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';

const HomeSeoSection = () => {
	return (
		<Row className="explainer" type="flex" justify="center">
			<Col md={22} lg={16} xl={16}>
				<Row>
					<Col xs={24} md={18}>
						<h1>Latest update: 11th March, 2022</h1>
						<p>
							<ul>
								<li>Improved performance of photo compressor.</li>
								<li>Fixed a bug in image size reducer library.</li>
							</ul>
						</p>
					</Col>
					<Col xs={24} md={18}>
						<h1>Free online photo size reducer tool to compress jpg & png files</h1>
						<h3>MozJpeg jpeg optimizer - Build by Mozilla, used by Instagram & Facebook</h3>
						<p>
							The gold standard for JPEG compression.
							MozJPEG improves JPEG compression efficiency achieving higher visual quality and smaller file sizes at the same time.
						</p>
					</Col>
					<Col xs={24} md={6} className="moz-icons">
						<FacebookOutlined style={{ fontSize: '48px', marginRight: '12px' }} />
						<InstagramOutlined style={{ fontSize: '48px' }} />
					</Col>
				</Row>
				<Row>
					<Col>
						<h1>Image compressor that can decrease image size upto 95%</h1>
						<p>
							Most compression algorithms are not intelligent enough to identify distortions
							of little subjective importance versus those objectionable to the user.
						</p>
						<p>
							Imagecompressor.io uses best in class compression techniques to minimize
							perceivable artifacts, distortion & pixelation. Result is a state of the art <b>photo size reducer</b> & <b>compressor.</b>
						</p>
					</Col>
				</Row>
				<Row type="flex" justify="space-between" gutter={8}>
					<Col xs={24} sm={8} className="explainer-card">
						<div>
							Latest Compression Techniques & Encoders
						</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>More Compression, Less Pixelated Images</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>Faster Websites, Better User Experience</div>
					</Col>
				</Row>
				<br />
				<h1>JPG Optimizer & Compressor - how does it work?</h1>
				<p>
					<a target="_blank" href="/blog/mozjpeg-guide">MozJPEG</a>
					&nbsp;is used to <b>compress JPEG</b> images.
				</p>
				<p>
					MozJPEG or Mozilla JPEG Encoder Project, an open source library developed by mozilla. MozJPEG reduces file sizes of JPEG images
					while retaining quality and compatibility with the vast majority of the world&apos;s deployed decoders.
				</p>
				<Row type="flex" justify="space-between" gutter={8}>
					<Col xs={24} sm={8} className="explainer-card">
						<div>
							Compress JPG files. Best JPG file compressor & reducer.
						</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>Smaller JPG size with no loss in quality</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>Extreme compress JPG - upto 90% reduced size in some cases</div>
					</Col>
				</Row>
				<br />
				<h1>PNG Optimizer & Compressor - How does it work?</h1>
				<p>
					PNG images are shrinked or compressed by a technique called &quot;Quantization&quot;.
					It reduces the number of distinct colors in the image, usually with the intention that the
					new image should be as visually similar as possible to the original image.
				</p>
				<p>
					Libraries <a target="_blank" rel="noopener noreferrer" href="https://pngquant.org/">PNGQuant</a>
					&nbsp;and <a target="_blank" rel="noopener noreferrer" href="https://encode.ru/threads/2274-ECT-an-file-optimizer-with-fast-zopfli-like-deflate-compression/">ECT</a>
					&nbsp;are used to <b>compress PNG</b> images.
				</p>
				<p>
					PNGquant is a lossy PNG compressor that significantly reduces file sizes by converting
					images to a more efficient 8-bit PNG format with alpha channel (quantization)
					- often 60-80% smaller than 24/32-bit PNG files.
				</p>
				<Row type="flex" justify="space-between" gutter={8}>
					<Col xs={24} sm={8} className="explainer-card">
						<div>
							Compress PNG files while preserving transparency.
						</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>Smaller PNG size with no loss in quality</div>
					</Col>
					<Col xs={24} sm={8} className="explainer-card">
						<div>Extreme compress PNG - upto 70% reduced size</div>
					</Col>
				</Row>
				<br />
				<h1>More Features</h1>
				<h3>Compress a folder or directory</h3>
				<p>You can now upload a folder or directory with images. Click on the Folder button to select the folder to upload.
					All jpeg & png files will be optimized using selected compression level.
				</p>
				<h3>Multiple Compression Modes</h3>
				<p>
					Four compression levels - Normal, Good, High, Extreme.
					Higher the compression, lower the image quality.
					We recommended <b>Good compression mode</b> as it maintains a fine balance
					between image quality & compression.
				</p>
			</Col>
		</Row>
	);
};

export default HomeSeoSection;



// WEBPACK FOOTER //
// ./src/HomeSeoSection.js